const relationshipToClaimant = {
	Mother: {
		name: "Mother",
		value: "Mother"
	},
	Father: {
		name: "Father",
		value: "Father"
	},
	Guardian: {
		name: "Guardian",
		value: "Guardian"
	}
};

const relationshipToClaimantOptions = [
	{ name: relationshipToClaimant.Mother.name, value: relationshipToClaimant.Mother.value },
	{ name: relationshipToClaimant.Father.name, value: relationshipToClaimant.Father.value },
	{ name: relationshipToClaimant.Guardian.name, value: relationshipToClaimant.Guardian.value }
];

const contactRelationshipToClaimant = {
	relationshipToClaimant: relationshipToClaimant,
	options: relationshipToClaimantOptions
};

export default contactRelationshipToClaimant;
